const initialState = {
    TotalNumberOfQuestionsReviewed: 10,
    booleanObserveStudyResponse: false,
    UID: '',
    stringResponse: '',
    ChosenQID: '',
    questionIndex: 0,
    UserSelectedAnswer: '',
    StudyModeSelectionOneText: '',
    StudyModeSelectionTwoText: '',
    StudyModeSelectionThreeText: '',
    StudyModeSelectionFourText: '',
    Question1: [],
    Question2: [],
    Question3: [],
    Question4: [],
    Question5: [],
    Question6: [],
    Question7: [],
    Question8: [],
    Question9: [],
    Question10: [],

}
//We dispatched the createLecture in the lectureAction.js.  This file needs to detect the createLecture.
const algorithmReducer = (state = initialState, action) => {
    //detect the createLecture through the switch statements.

    switch (action.type) {

        case 'ProcessStudyResults':
            return{
                ...state,
                booleanObserveStudyResponse: action.booleanObserveStudyResponse,
                UID: action.UID,
                stringResponse: action.stringResponse,
                ChosenQID: action.ChosenQID,
                UserSelectedAnswer: action.UserSelectedAnswer,
                StudyModeSelectionOneText: action.StudyModeSelectionOneText,
                StudyModeSelectionTwoText: action.StudyModeSelectionTwoText,
                StudyModeSelectionThreeText: action.StudyModeSelectionThreeText,
                StudyModeSelectionFourText: action.StudyModeSelectionFourText,
            }

        case 'StoreResponse':
            return{
                ...state,
                booleanObserveStudyResponse: action.booleanObserveStudyResponse,
            }




        case 'IDENTIFY_QUESTION_LIST_ACTION':

            if(action.Question1){

                return {

                    ...state,
                    questionIndex: action.questionIndex,
                    Question1: action.Question1,
                    Question2: action.Question2,
                    Question3: action.Question3,
                    Question4: action.Question4,
                    Question5: action.Question5,
                    Question6: action.Question6,
                    Question7: action.Question7,
                    Question8: action.Question8,
                    Question9: action.Question9,
                    Question10: action.Question10,
                    
                }
            }

            //There isn't a question in 10.  Needs to set everything to 0.
            else{
                return {

                    ...state,
                    TotalNumberOfQuestionsReviewed: -1,
                    questionIndex: -1,
                    Question1: {},
                    Question2: {},
                    Question3: {},
                    Question4: {},
                    Question5: {},
                    Question6: {},
                    Question7: {},
                    Question8: {},
                    Question9: {},
                    Question10: {},
                    
                }
            }


        default:
            return state;
    }

}

export default algorithmReducer